/* Florelle: quantity/remove for cart-drawer rows that merge several lines of the same variant
   (Shopify splits lines when a Buy X Get Y discount applies). Sets the first line to the new
   total and zeroes the rest, then re-renders the drawer. */
(function () {
  if (window.__flCartMerge) return;
  window.__flCartMerge = true;

  function setTotal(keys, qty, row) {
    var updates = {};
    keys.forEach(function (k, i) { updates[k] = i === 0 ? qty : 0; });
    if (row) row.style.opacity = '0.5';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.renderContents === 'function') d.renderContents({ id: null, sections: sections });
      })
      .catch(function () { if (row) row.style.opacity = ''; });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[data-fl-keys]')) return;
    e.stopImmediatePropagation();
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    setTotal(input.dataset.flKeys.split(','), qty, input.closest('.cart-item'));
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.cart-remove-button[data-fl-keys]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    setTotal(btn.dataset.flKeys.split(','), 0, btn.closest('.cart-item'));
  }, true);
})();
